//EmployeeInvite.js
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../firebase/config";
import StatusBanner from "../components/StatusBanner";
import { getUserDetails } from "../firebase/auth"; // you already have this
import "../styles/Login.css"; // optional reuse styling

const FUNCTIONS_BASE = process.env.REACT_APP_FUNCTIONS_BASE;

export default function EmployeeInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [error, setError] = useState(null);

  useEffect(() => {
    const run = async () => {
      const token = params.get("token");
      const email = params.get("email");

      if (!token || !email) {
        setError({
          title: "Invalid invite link",
          message: "This invite link is missing required information.",
        });
        return;
      }

      try {
        // 1) Exchange invite token -> customToken
        const res = await fetch(`${FUNCTIONS_BASE}/redeemEmployeeInvite`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, email }),
        });

        const data = await res.json();
        if (!res.ok)
          throw new Error(data?.error || "Invite redemption failed.");

        // 2) Sign in automatically
        await signInWithCustomToken(auth, data.customToken);

        // 3) Load user details & apply SAME routing logic you already use
        const userDetails = await getUserDetails(auth.currentUser.uid);

        if (!userDetails) {
          throw new Error(
            "Signed in, but could not load your account details."
          );
        }

        if (userDetails.status === "Pending") {
          navigate("/reset-password", { replace: true });
          return;
        }

        if (
          userDetails.profileCompleted === false &&
          userDetails.selfOnboarding === true
        ) {
          navigate("/onboarding", { replace: true });
          return;
        }

        navigate("/employee-dashboard", { replace: true });
      } catch (e) {
        setError({
          title: "Invite link failed",
          message:
            e.message || "This invite link may be expired or already used.",
        });
      }
    };

    run();
  }, [params, navigate]);

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-box">
          <h1 className="login-title">Signing you in…</h1>
          <p className="login-subtext">
            Please wait while we securely log you into your account.
          </p>

          {error && (
            <StatusBanner
              type="error"
              title={error.title}
              message={error.message}
              onClose={() => setError(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
